// ================================================================================================
import { BoardTheming } from './BoardTheming';
import { DashboardConfiguration, DashboardViewExt, PollingScale, PageLayoutPolicy, DashboardType } from '@ModelViews/ModelViews';
import { getRandomSmallKey } from '@Utils/Micro';
import { IWidgetDictionary } from '@UI/Widgets/WidgetStructs';
// ================================================================================================
// Structs
// ================================================================================================
export declare type DashboardDescriptorKey = string;

export interface DashboardDescriptor extends DashboardViewExt {
    /**
     * Runtime information for selected widgets
     */
    Widgets: IWidgetDictionary;
}
export declare type DashboardDescriptorDictionary = { [key: string]: DashboardDescriptor };

// ================================================================================================
// Helper
// ================================================================================================
export class DashboardHelper {
    public static getDefaultConfiguration(): DashboardConfiguration {
        const theme = BoardTheming.GetActiveTheme();
        return {
            Name: "Dashboard",
            Desc: "Yodiwo Dashboard",
            PageId: getRandomSmallKey(),
            Icon: null,
            GridLayout: true,
            Margin: { W: 4, H: 4 },
            VerticalCompact: true,
            BackgroundImage: "",
            MobileBackgroundImage: "",
            CanvasBackgroundColor: theme.boardGrid.backgroundColor,
            OverrideCanvasBackgroundColor: false,
            WidgetBackgroundColor: "rgb(255, 255, 255)",
            OverrideWidgetBackgroundColor: false,
            WidgetNoBackground: false,
            Order: 0,
            Path: "/",
            IsHidden: false,
            ZDepth: 2,
            OverrideZDepth: false,
            MaxPageWidth: 2600,
            Polling: {
                Enabled: false,
                Period: 10,
                EnabledOnlyInFocus: true,
                SendPollInRefocus: true,
                PeriodScale: PollingScale.Sec
            },
            LayoutPolicy: PageLayoutPolicy.FillHeight,
            NumberOfVerticalGridSpaces: 12,
            SessionBasedPortData: true,
            BorderRadius: 14,
            OverrideBorderRadius: false,
            Outline: {
                Thickness: 0,
                Color: 'rgb(189, 189, 189)'
            },
            Deleted: false,
            Padding: 5,
            Type: DashboardType.Page
        };
    }
}